module.exports = __webpack_public_path__ + "static/media/minus.0f1d7216.svg";